module.exports = __webpack_public_path__ + "bbb5b9c91f6cdb1a6ec9ac59611fbf99.woff";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-100.woff
// module id = 453
// module chunks = 0